import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import { moneyFormat } from '../../../../../services/util';
import Descriptions from '../../../../molecules/Descriptions';

const DescontosWrapper = styled.div`
  display: flex;
  gap: 10px;
`;

function TabelaDescontos({ descontos }) {
  const { inss, irrf, irrfComplementar } = descontos;
  return (
    <DescontosWrapper>
      <Descriptions title="Descontos CLT">
        <Descriptions.Item label="INSS">
          <span data-testid="inss">{moneyFormat(inss)}</span>
        </Descriptions.Item>
        <Descriptions.Item label="IRRF">
          <span data-testid="irrf">{moneyFormat(irrf)}</span>
        </Descriptions.Item>
      </Descriptions>
      <Descriptions title="Descontos Complementares">
        <Descriptions.Item label="IRRF Complementar">
          <span data-testid="irrfComplementar">
            {moneyFormat(irrfComplementar)}
          </span>
        </Descriptions.Item>
      </Descriptions>
    </DescontosWrapper>
  );
}

TabelaDescontos.propTypes = {
  descontos: PropTypes.shape({
    inss: PropTypes.number,
    irrf: PropTypes.number,
    irrfComplementar: PropTypes.number,
  }),
};

TabelaDescontos.defaultProps = {
  descontos: {
    inss: 0,
    irrf: 0,
    irrfComplementar: 0,
  },
};

export default TabelaDescontos;
